import React, { Suspense } from 'react'
import { Route, BrowserRouter, Routes } from 'react-router-dom'
import HookieFormPage from '../pages/HookieFormPage/HookieFormPage'
import ChristmasDinnerFormPage from '../pages/ChristmasDinnerFormPage/ChristmasDinnerFormPage'
import ChristmasDinner2025FormPage from '../pages/ChristmasDinner2025FormPage/ChristmasDinner2025FormPage'
import ChristmasDinner2026FormPage from '../pages/ChristmasDinner2026FormPage/ChristmasDinner2026FormPage'
import withAdminAuth from '../auth/withAdminAuth'

// Lazy load pages
const ExportPage = React.lazy(async () => await import('../pages/ExportPage/ExportPage'))
const MembershipFormPage = React.lazy(async () => await import('../pages/MembershipFormPage/MembershipFormPage'))
const BackdoorMembershipFormPage = React.lazy(async () => await import('../pages/MembershipFormPage/BackdoorMembershipFormPage'))
const TokenManagerPage = React.lazy(async () => await import('../pages/TokenManagerPage/TokenManagerPage'))
const BlacklistPage = React.lazy(async () => await import('../pages/BlacklistPage/BlacklistPage'))
const FreeListPage = React.lazy(async () => await import('../pages/FreeListPage/FreeListPage'))
const RegistrationsPage = React.lazy(async () => await import('../pages/RegistrationsPage/RegistrationsPage'))
const ChristmasDinner2026AdminPage = React.lazy(async () => await import('../pages/ChristmasDinner2026AdminPage/ChristmasDinner2026AdminPage'))
const DinnerVotingPage = React.lazy(async () => await import('../pages/DinnerVotingPage/DinnerVotingPage'))
const DinnerVotingAdminPage = React.lazy(async () => await import('../pages/DinnerVotingAdminPage/DinnerVotingAdminPage'))
const DashboardPage = React.lazy(async () => await import('../pages/DashboardPage/DashboardPage'))
const NotFoundPage = React.lazy(async () => await import('../pages/NotFoundPage/NotFoundPage'))
const HomePage = React.lazy(async () => await import('../pages/HomePage/HomePage'))

// Create authenticated versions of the admin pages
const AuthenticatedExportPage = withAdminAuth(ExportPage)
const AuthenticatedTokenManagerPage = withAdminAuth(TokenManagerPage)
const AuthenticatedBlacklistPage = withAdminAuth(BlacklistPage)
const AuthenticatedFreeListPage = withAdminAuth(FreeListPage)
const AuthenticatedRegistrationsPage = withAdminAuth(RegistrationsPage)
const AuthenticatedChristmasDinner2026AdminPage = withAdminAuth(ChristmasDinner2026AdminPage)
const AuthenticatedDinnerVotingAdminPage = withAdminAuth(DinnerVotingAdminPage)
const AuthenticatedDashboardPage = withAdminAuth(DashboardPage)

const AppRouter = (): JSX.Element => (
    <BrowserRouter>
        <Suspense fallback={<div>Loading...</div>}>
            <Routes>
                {/* Public Routes */}
                <Route path="/" element={<HomePage/>}/>
                <Route path="/membership-form" element={<MembershipFormPage/>}/>
                <Route path="/hookie" element={<HookieFormPage/>}/>
                <Route path="/christmas-dinner" element={<ChristmasDinnerFormPage/>}/>
                <Route path="/christmas-dinner-2025" element={<ChristmasDinner2025FormPage/>}/>
                <Route path="/christmas-dinner-2026" element={<ChristmasDinner2026FormPage/>}/>
                <Route path="/votacion" element={<DinnerVotingPage/>}/>
                <Route path="/invitacion" element={<BackdoorMembershipFormPage/>}/>

                {/* Admin Routes */}
                <Route path="/admin/exports" element={<AuthenticatedExportPage />}/>
                <Route path="/admin/tokens" element={<AuthenticatedTokenManagerPage />}/>
                <Route path="/admin/dashboard" element={<AuthenticatedDashboardPage />}/>
                <Route path="/admin/registrations" element={<AuthenticatedRegistrationsPage />}/>
                <Route path="/admin/christmas-dinner" element={<AuthenticatedChristmasDinner2026AdminPage />}/>
                <Route path="/admin/votes" element={<AuthenticatedDinnerVotingAdminPage />}/>
                <Route path="/admin/blacklist" element={<AuthenticatedBlacklistPage />}/>
                <Route path="/admin/free-list" element={<AuthenticatedFreeListPage />}/>

                {/* Not Found */}
                <Route path="*" element={<NotFoundPage/>}/>
            </Routes>
        </Suspense>
    </BrowserRouter>
)

export default AppRouter
